/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

__webpack_require__(2);

var _module = __webpack_require__(3);

var root = function (root) {
	if ((typeof root === 'undefined' ? 'undefined' : _typeof(root)) === 'object' && (root.self === root || root.global === global) && root) {
		return root;
	}
}(self || global || {});

var $ = function ($) {
	if (typeof $ === 'function') {
		return $;
	} else {
		throw 'You must import jQuery';
	}
}(root.jQuery);

$.fn[_module.ModuleName] = function () {
	var module = void 0;
	var args = Array.prototype.slice.call(arguments, 0);
	var method = args[0];
	var options = args.slice(1).length <= 0 ? undefined : args.slice(1, args.length);;
	var isReturnMethod = this.length === 1 && typeof method === 'string' && _module.ModuleReturns.indexOf(method) !== -1;
	var methodRunner = function methodRunner(method, options, uesReturn) {
		var $this = $(this);
		var module = $this.data(_module.ModuleName);
		if (!!module) {
			if (typeof method == 'string' && !uesReturn) {
				module[method].apply(module, options);
			} else if (typeof method == 'string' && !!uesReturn) {
				return module[method].apply(module, options);
			} else {
				throw 'unsupported options!';
			}
		} else {
			throw 'You must run first this plugin!';
		}
	};
	if (isReturnMethod) {
		return methodRunner.call(this, method, options, isReturnMethod);
	} else {
		return this.each(function () {
			var $this = $(this);
			var module = $this.data(_module.ModuleName);
			var opts = null;
			if (!!module) {
				methodRunner.call(this, method, options);
			} else {
				opts = $.extend(true, {}, _module.ModuleDefaults, (typeof method === 'undefined' ? 'undefined' : _typeof(method)) === 'object' && method, (typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object' && options);
				module = new _module.Module(this, opts);
				$this.data(_module.ModuleName, module);
				module.init();
			}
		});
	}
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 1 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ModuleName = 'sf_lnse';

var ModuleDefaults = {
    $tabsWrap: undefined,
    toggleTabs: true,
    renderHiddenToggle: false,
    needHiddenInputsChangeEvents: 'change',
    fromChangeEventName: 'change',
    fieldRecodeWriteEvent: 'recodeLoaded',
    switchEnableDisable: 'false',
    reocodeDataOnDomKey: 'recode',
    urlFirst: false,
    urlMatches: null,
    urlRegex: 'regex',
    urlReplacedTo: 'replacedTo',
    urlActivePanlParam: '_activeSection',
    urlActivePanlDefault: '', //Active panel by default
    urlConcat: 'concatVal',
    urlConcatPrimary: 'primary',
    urlCheckedVal: 'checkedVal',
    storageSetting: {
        key: 'sf-lnse',
        lastSearchKey: 'panelLastSubmit'
    },
    whenInit: function whenInit($module) {
        console.log('whenInit Callback', $module);
    },
    whenRecodeWrited: function whenRecodeWrited($visiablePanlWrap, $input, $inputHidden) {
        console.log('whenRecodeWrited Callback', $input, $inputHidden);
    },
    whenTabSwitchDone: function whenTabSwitchDone($visiablePanlWrap) {
        console.log('whenTabSwitchDone Callback', $visiablePanlWrap);
    },
    whenInputRemoved: function whenInputRemoved($inputDom) {
        console.log('whenInputRemoved Callback', $inputDom);
    },
    whenFormChanged: function whenFormChanged($visiablePanlWrap, $input, $inputHidden) {
        console.log('whenFormChanged Callback', $input, $inputHidden);
    },
    whenBeforeSubmit: function whenBeforeSubmit($visiablePanlWrap, $submit) {
        console.log('whenBeforeSubmit Callback', $visiablePanlWrap, $submit);
    },
    whenSubmit: function whenSubmit($visiablePanlWrap, $submit) {
        console.log('whenSubmit Callback', $visiablePanlWrap, $submit);
    },
    whenEnabled: function whenEnabled($this) {
        console.log('whenEnabled Callback', $this);
    },
    whenDisabled: function whenDisabled($this) {
        console.log('whenDisabled Callback', $this);
    }
};

var ModuleReturns = [];

var Module = function () {
    function Module(ele, option) {
        _classCallCheck(this, Module);

        this.ele = ele;
        this.$ele = $(ele);
        this.$panels = this.$ele.find('[data-panl]');
        this.$submit = this.$ele.find('button[type=submit]');
        this.option = option;
    }

    _createClass(Module, [{
        key: 'init',
        value: function init() {
            var $inputFocusRemove = this.$ele.find('[data-toggle=focusRemove]');
            var $needHiddenInputs = this.$ele.find('[data-hiddenInput]');
            var $needTriggerChangeInputs = this.$ele.find('select,input[type!=hidden]:not([data-hiddenInput])');
            var $needTriggerRecodeLoadedInputs = this.$ele.find('select,input[type!=hidden]');
            var $this = this.$ele;
            var $panels = this.$ele.find('[data-panl]');
            var self = this;
            // Init
            this.option.whenInit($this);
            /*$this.data('sf-lnse', {
                $submit: this.$submit,
                $panels: $panels
            });*/
            // 啟動Tab 功能
            if (this.option.toggleTabs) {
                $.each(this.option.$tabsWrap, function (i, $thisDom) {
                    $thisDom.each(function (number, dom) {
                        self.tab($(dom), $this);
                    });
                });
            }
            // 加入focus remove 功能
            $inputFocusRemove.each(function (i, $thisDom) {
                self.focusRemove($thisDom);
            });
            // Render 隱藏input
            if (this.option.renderHiddenToggle) {
                this.renderHiddenValue($needHiddenInputs, this.option.needHiddenInputsChangeEvents);
            }
            // 註冊 module 下所有 field 的change 事件
            $needTriggerChangeInputs.on(this.option.fromChangeEventName, function (e) {
                self.option.whenFormChanged($this.find('.ctns').children('.active:visible:last'), $(this), null);
            });
            // 註冊 module 下所有 field Recode Loaded 事件
            $needTriggerRecodeLoadedInputs.on(this.option.fieldRecodeWriteEvent, function (e, $input) {
                var $thisPanl = $input.closest('.panl[data-panl]');
                self.option.whenRecodeWrited($thisPanl, $input, self.getHiddenInputDoms($input));
            });
            // 讀取上一次的搜尋記錄
            this.lastSearchData().init($panels);
            // Submit Callback
            this.$submit.on('click', function (e) {
                var $visiablePanlWrap = $this.find('[data-panl]:visible:last');
                // Submit 前檢查
                if (self.requiredVerfiy($visiablePanlWrap)) {
                    // Submit Callback
                    self.option.whenBeforeSubmit($visiablePanlWrap, $(this));
                    self.lastSearchData().save($visiablePanlWrap);
                    self.option.whenSubmit($visiablePanlWrap, $(this));
                }
            });
        }
    }, {
        key: 'tab',
        value: function tab($dom, $sfWrap) {
            // 如果dom只有一個就將options.el抓給el，如果options.el沒有東西，就給options.dom抓好的dom
            var self = this;
            var el = $dom;
            var $tabNavigationLinks = el.children('.tabs').children('li');
            var $tabContentContainers = el.children('.ctns').children('.panl');
            var activeIndex = 0;

            var init = function init() {
                for (var i = 0; i < $tabNavigationLinks.length; i++) {
                    var link = $tabNavigationLinks.eq(i);
                    handleClick(link, i);
                }
                if ($tabNavigationLinks.eq(activeIndex).find('input[type=radio]').length > 0) {
                    $tabNavigationLinks.eq(activeIndex).find('input[type=radio]').prop('checked', true);
                }
                $tabNavigationLinks.eq(activeIndex).addClass('active');
                $tabContentContainers.eq(activeIndex).addClass('active');
            };
            var handleClick = function handleClick($link, index) {
                $link.on('click', function (e) {
                    goToTab(index);
                });
            };
            var goToTab = function goToTab(index) {
                if (index !== activeIndex && index >= 0 && index <= $tabNavigationLinks.length) {
                    $tabNavigationLinks.eq(activeIndex).removeClass('active');
                    $tabNavigationLinks.eq(index).addClass('active');
                    $tabContentContainers.eq(activeIndex).removeClass('active');
                    $tabContentContainers.eq(index).addClass('active');
                    activeIndex = index;
                }
                // 將資料編輯區的wrapper dom 傳給 whenTabSwitchDone callback
                self.option.whenTabSwitchDone(self.$ele.find('.ctns').children('.active:visible:last'));
            };
            init();
        }
    }, {
        key: 'focusRemove',
        value: function focusRemove(dom) {
            var self = this;
            var $input = $(dom).children('input'),
                $addon = $(dom).children('.addon');

            !$(dom).hasClass('intg') && $(dom).addClass('intg');
            if ($addon.length == 0) {
                $input.after($('<span class="addon"><button class="seic icon-round-times"></button></span>'));
                $addon = $(dom).children('.addon');
            }

            $addon.hide();
            $input.on('keyup', function () {
                if ($(this).val().length > 0) {
                    $addon.show();
                } else {
                    $addon.hide();
                    self.option.whenInputRemoved($input);
                }
            });
            $input.on('focus', function () {
                $(this).val().length > 0 && $addon.show();
            });
            $input.on('focusout', function () {
                $addon.hide();
            });
            $addon.on('mousedown', function () {
                $input.val(null);
                $addon.hide();
                self.option.whenInputRemoved($input);
            });
        }
    }, {
        key: 'renderHiddenValue',
        value: function renderHiddenValue($inputs, eventName) {
            var self = this;
            var $module = this.$ele;
            var $visiablePanlWrap = $module.find('.ctns').children('.active:visible:last');
            $inputs.each(function (i, $this) {
                var inputName = $(this).attr('data-hiddenInput');
                var inputHtml = function inputHtml(string) {
                    var html = '';
                    if (string.indexOf(',') != -1) {
                        var array = string.split(',');
                        for (var i = 0; i < array.length; i++) {
                            html += '<input type="hidden" name="' + array[i] + '">';
                        }
                    } else {
                        html = '<input type="hidden" name="' + inputName + '">';
                    }
                    return html;
                };
                var $inputHidden = $(inputHtml(inputName));
                $(this).after($inputHidden);
                // 註冊事件後即啟動是要更新已經下的預設值
                $(this).on(eventName, function (e, inputDom) {
                    if (eventName != 'change' && !!inputDom) {
                        self.option.whenFormChanged($visiablePanlWrap, $(inputDom), $inputHidden);
                    } else {
                        self.option.whenFormChanged($visiablePanlWrap, $(this), $inputHidden);
                    }
                });
            });
        }
    }, {
        key: 'getHiddenInputDoms',
        value: function getHiddenInputDoms($input) {
            var self = this;
            var $returnDoms = null;
            var hiddenInputArray = [];
            var hiddenInputName = '';
            var multiSelectorString = '';
            var $inputInPanel = $input.closest('.panl[data-panl]');
            if ($input.is('[data-hiddenInput]') && !!$input.attr('data-hiddenInput')) {
                hiddenInputName = $input.attr('data-hiddenInput');
                if (hiddenInputName.indexOf(',') != -1) {
                    hiddenInputArray = hiddenInputName.split(',');
                    for (var i = 0; i < hiddenInputArray.length; i++) {
                        multiSelectorString += 'input[type="hidden"][name="' + hiddenInputArray[i] + '"]';
                        if (i + 1 !== hiddenInputArray.length) {
                            multiSelectorString += ',';
                        }
                    }
                    $returnDoms = $(multiSelectorString, $inputInPanel);
                } else {
                    $returnDoms = $('input[type="hidden"][name="' + hiddenInputName + '"]');
                }
            }
            return $returnDoms;
        }
    }, {
        key: 'lastSearchData',
        value: function lastSearchData() {
            var self = this;
            var settings = this.option;
            var storageKey = this.option.storageSetting.key;
            var lastSearchKey = this.option.storageSetting.lastSearchKey;
            var storageValue = function (value) {
                if (typeof value === 'string') {
                    var result = value.match(/(^\{|\}$)/);
                    if (result.length == 2) {
                        return JSON.parse(value);
                    }
                } else {
                    return null;
                }
            }(localStorage.getItem(storageKey));
            var fieldType = function fieldType($ele) {
                var nodeName = $ele.prop('nodeName');
                var customtype = $ele.attr('data-savecustom');
                if (nodeName === 'INPUT') {
                    if (typeof customtype !== 'undefined') {
                        return 'custom';
                    } else {
                        return $ele.attr('type');
                    }
                } else if (nodeName === 'SELECT') {
                    return 'select';
                }
            };
            var fieldValue = function fieldValue($ele, type) {
                switch (type) {
                    case 'radio':
                    case 'checkbox':
                        if ($ele.prop('checked')) {
                            return $ele.val();
                        } else {
                            return null;
                        }
                        break;
                    case 'custom':
                        var obj = {};
                        var keys = $ele.attr('data-savecustom').split(',');
                        var key;
                        for (var i = 0; i < keys.length; i++) {
                            key = keys[i];
                            obj[key] = $ele.attr('data-' + key);
                        }
                        return obj;
                        break;
                    default:
                        if ($ele.val().length > 0) {
                            return $ele.val();
                        }
                        break;
                }
            };
            var expired = function expired(expiry) {
                var today = new Date();
                var exdate = new Date(expiry);
                if (today.getTime() >= exdate.getTime()) {
                    return true;
                } else {
                    return false;
                }
            };
            // Public 方法
            var loadStorageData = function loadStorageData($panels) {
                var loadByUrl = !!window.location.search && settings.urlFirst === true && !!settings.urlMatches;
                if (loadByUrl) {
                    var paramObj = getURLParamObj(window.location.search.substr(1)),
                        panelName = paramObj[settings.urlActivePanlParam];

                    if (!panelName && settings.urlActivePanlDefault) {
                        panelName = settings.urlActivePanlDefault;
                    }
                    if (!!panelName && !!settings.urlMatches[panelName]) {
                        var $inputs = $('[data-panl=' + panelName + ']').find('[data-save]');
                        !!panelName ? $panels = $panels.not("[data-panl=" + panelName + "]") : $panels;

                        $inputs.each(function (i, input) {
                            var $input = $(input),
                                key = $input.attr('data-save'),
                                regex = "",
                                replacedTo = "",
                                replaceVal = "";
                            if (!!settings.urlMatches[panelName][key]) {
                                if (!!settings.urlMatches[panelName][key][settings.urlConcat]) {
                                    var concatObj = settings.urlMatches[panelName][key][settings.urlConcat];
                                    var concatKeys = Object.keys(concatObj);
                                    for (var j = 0; j < concatKeys.length; j++) {
                                        var concatKey = concatKeys[j];
                                        var item = concatObj[concatKey];
                                        if (!!concatObj[concatKey][settings.urlConcatPrimary] && concatObj[concatKey][settings.urlConcatPrimary] === true && !paramObj[concatKey]) {
                                            regex = new RegExp(settings.urlMatches[panelName][key][settings.urlRegex], 'g');
                                            replacedTo = settings.urlMatches[panelName][key][settings.urlReplacedTo];
                                            replaceVal = paramObj[key] ? paramObj[key].replace(regex, replacedTo) : '';
                                            break;
                                        } else {
                                            regex = new RegExp(item[settings.urlRegex], 'g');
                                            replacedTo = item[settings.urlReplacedTo];
                                            replaceVal += paramObj[concatKey].replace(regex, replacedTo);
                                        }
                                    }
                                } else {
                                    regex = new RegExp(settings.urlMatches[panelName][key][settings.urlRegex], 'g');
                                    replacedTo = settings.urlMatches[panelName][key][settings.urlReplacedTo];
                                    if (!!paramObj[key]) replaceVal = paramObj[key].replace(regex, replacedTo);
                                }
                                var inputType = fieldType($input);
                                if (!!replaceVal || inputType === "custom") {
                                    switch (inputType) {
                                        case 'checkbox':
                                            !!settings.urlMatches[panelName][key][settings.urlCheckedVal] && replaceVal == settings.urlMatches[panelName][key][settings.urlCheckedVal] && $input.data(settings.reocodeDataOnDomKey, replaceVal).prop('checked', true).trigger(settings.fieldRecodeWriteEvent, [$input]);
                                            break;
                                        case 'radio':
                                            $input.data(settings.reocodeDataOnDomKey, replaceVal).filter('[value=' + replaceVal + ']').prop('checked', true).trigger(settings.fieldRecodeWriteEvent, [$input]);
                                            break;
                                        case 'select':
                                            $input.find('option').attr('selected', null);
                                            $input.data(settings.reocodeDataOnDomKey, replaceVal).find('option[value="' + replaceVal + '"]').prop('selected', true).attr('selected', 'selected');
                                            $input.trigger(settings.fieldRecodeWriteEvent, [$input]);
                                            break;
                                        case 'custom':
                                            var customObj = null;
                                            if (!!settings.urlMatches[panelName][key].custom) customObj = settings.urlMatches[panelName][key].custom;
                                            if (!!customObj && (typeof customObj === 'undefined' ? 'undefined' : _typeof(customObj)) === 'object') {
                                                var customObjKey = Object.keys(customObj);
                                                for (var key in customObj) {
                                                    $input.attr(key, paramObj[customObj[key]]);
                                                }
                                            }
                                            break;
                                        default:
                                            $input.data(settings.reocodeDataOnDomKey, replaceVal).val(replaceVal).trigger(settings.fieldRecodeWriteEvent, [$input]);
                                            break;
                                    };
                                }
                            }
                        });
                    } else console.log("Cannot find " + settings.urlActivePanlParam + "on URL");
                }
                if (!!storageValue) {

                    // console.log("$panels", $panels) 
                    !!storageValue[lastSearchKey] && $panels.each(function (i, ele) {
                        var $panel = $(ele);
                        var panelKey = $panel.attr('data-panl');
                        var panelValue = !!storageValue[lastSearchKey][panelKey] ? storageValue[lastSearchKey][panelKey] : null;

                        if (!!panelValue) {
                            // 取出設有data-save屬性的dom 
                            var $inputForSave = $panel.find('[data-save]');
                            // 開始遍歷每一個被標記要存值的Field 
                            $inputForSave.each(function (i, input) {
                                var $input = $(input);
                                var inputKey = $input.attr('data-save');
                                var inputType = fieldType($input);
                                var inputValue = !!panelValue[inputKey] ? panelValue[inputKey] : null;

                                if (inputValue != null && !expired(inputValue.date.expired)) {
                                    // 讀取上一次搜尋記錄並寫入filed後就啟動該field的change事件 
                                    switch (inputType) {
                                        case 'checkbox':
                                            inputValue.value == 'on' && $input.data(settings.reocodeDataOnDomKey, inputValue.value).prop('checked', true).trigger(settings.fieldRecodeWriteEvent, [$input]);
                                            break;
                                        case 'radio':
                                            $input.data(settings.reocodeDataOnDomKey, inputValue.value).filter('[value=' + inputValue.value + ']').prop('checked', true).trigger(settings.fieldRecodeWriteEvent, [$input]);
                                            break;
                                        case 'select':
                                            $input.find('option').attr('selected', null);
                                            $input.data(settings.reocodeDataOnDomKey, inputValue.value).find('option[value="' + inputValue.value + '"]').prop('selected', true).attr('selected', 'selected');
                                            $input.trigger(settings.fieldRecodeWriteEvent, [$input]);
                                            break;
                                        case 'custom':
                                            if (_typeof(inputValue.value) === 'object') {
                                                for (var key in inputValue.value) {
                                                    $input.attr('data-' + key, inputValue.value[key]);
                                                }
                                                $input.data(settings.reocodeDataOnDomKey, inputValue.value).prop('value', function (obj) {
                                                    if (typeof obj.merged === "string" && obj.merged.length > 0) {
                                                        return obj.merged;
                                                    } else if (typeof obj.txt === "string") {
                                                        return obj.txt;
                                                    } else if (typeof obj.intvalue === "string") {
                                                        return obj.intvalue;
                                                    }
                                                }(inputValue.value)).trigger(settings.fieldRecodeWriteEvent, [$input]);
                                            }
                                            break;
                                        default:
                                            $input.data(settings.reocodeDataOnDomKey, inputValue.value).val(inputValue.value).trigger(settings.fieldRecodeWriteEvent, [$input]);
                                            break;
                                    };
                                }
                            });
                        }
                    });
                    return true;
                } else {
                    return false;
                }
            };
            var savePanelInputData = function savePanelInputData($panel) {
                var saveKey = storageKey;
                var saveValue = !!storageValue ? storageValue : {};
                var rootKey = lastSearchKey;
                var rootValue = !!saveValue[rootKey] ? saveValue[rootKey] : {};
                var panelKey = $panel.attr('data-panl');
                var panelValue = {};
                // 取出設有data-save屬性的dom
                var $inputForSave = $panel.find('[data-save]');
                // 開始遍歷每一個被標記要存值的Field
                $inputForSave.each(function (i, ele) {
                    var $input = $(ele);
                    var inputKey = $input.attr('data-save');
                    var type = fieldType($input);
                    var value = fieldValue($input, type);
                    var today = new Date();
                    var expiry = new Date();
                    expiry.setDate(expiry.getDate() + 30);
                    var InputVal = {
                        value: value,
                        fieldType: type,
                        date: {
                            create: today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() + ' ' + today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds(),
                            expired: expiry.getFullYear() + '-' + (expiry.getMonth() + 1) + '-' + expiry.getDate() + ' ' + expiry.getHours() + ':' + expiry.getMinutes() + ':' + expiry.getSeconds()
                        }
                    };
                    if (value != null) {
                        panelValue[inputKey] = InputVal;
                    }
                });
                rootValue[panelKey] = panelValue;
                saveValue[rootKey] = rootValue;
                localStorage.setItem(saveKey, JSON.stringify(saveValue));
            };
            if (typeof Storage !== "undefined") {} else {
                console.log('您的browser不支援web storage喔！');
            }
            return {
                init: loadStorageData,
                save: savePanelInputData
            };
        }
    }, {
        key: 'requiredVerfiy',
        value: function requiredVerfiy($panel, callback) {
            var self = this;
            var $requireds = $panel.find('[data-required=true]:visible');
            var verfiyPass = [];
            var alertStrings = [];
            $requireds.each(function (i, ele) {
                var $this = $(ele);
                var alertSting = function (val) {
                    var string = val;
                    if (typeof string === 'undefined') {
                        string = '請輸入必填欄位喔！';
                    }
                    return string;
                }($this.attr('data-reqString'));
                if ($this.val() == null || $this.val().length == 0) {
                    alertStrings.push(alertSting);
                    verfiyPass.push(false);
                } else {
                    verfiyPass.push(true);
                }
            });
            if (alertStrings.length > 0) {
                alert(alertStrings.filter(function (elem, index, self) {
                    return index == self.indexOf(elem);
                }).join('、'));
            }
            return verfiyPass.indexOf(false) == -1 ? true : false;
        }
    }, {
        key: 'getURLParamObj',
        value: function getURLParamObj(locationSearch) {
            var self = this;
            var paramObj = {};
            if (!locationSearch) {
                console.log("There's no parameter of the URL.");
            } else if (typeof locationSearch == 'string') {
                var paramArray = [];
                paramArray = locationSearch.split("&");
                if (!!paramArray) {
                    for (var i = 0; i < paramArray.length; i++) {
                        var itemArray = paramArray[i].split("=");
                        paramObj[itemArray[0]] = decodeURI(itemArray[1]);
                    }
                }
            }
            // console.log("paramObj", paramObj);
            return paramObj;
        }
    }]);

    return Module;
}();

;

exports.ModuleName = ModuleName;
exports.ModuleDefaults = ModuleDefaults;
exports.ModuleReturns = ModuleReturns;
exports.Module = Module;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// ./magaele/sf-lnse/module.js